import { useQuery } from "@tanstack/react-query";
import usersAPI from "features/Setting/users/api/userApis";

const onSuccess = (data) => {
  console.log("Performing  Afther data fecthing", data.data);
};

const onError = (error) => {
  console.log("Performing Afther error encountring", error);
};

const useGetAllUsersData = ({ sortBy = "createdAt", sortOrder = "desc", search = "" } = {}) => {
  return useQuery({
    queryKey: ["users-data", { sortBy, sortOrder, search }],
    queryFn: () => usersAPI.getAllUserData({ sortBy, sortOrder, search }),
    cacheTime: 200000,
    staleTime: 20000,
    refetchOnWindowFocus: true,
  });
};

export default useGetAllUsersData;
